export default {
  message: {
    attachments: []
  },
  chatClosingLoading: false,
  unsendedQuoteMessage: undefined,
  reading: false,
  ticket: undefined,
  typing: false,
  chat: undefined,
  scrollBottom: false,
  messages: [],
  surveyAnswered: false,
  creatingChat: false,
  focusedMessageKey: undefined,
  emojiPageStatus: undefined,
  showKbCard: false,
  comment: '',
  commentError: false,
  voiceRecording: false,
  dragging: false,
  showNumberInput: false,
  showDatePicker: false,
  numberInputValid: false,
  datePickerValid: {
    status: false,
    message: ''
  },
  hasUploadInProcess: false,
  token: ''
}
